export default {
  "confirm-action.error.unexpected.title": "Etwas ist schief gelaufen",
  "confirm-action.error.unexpected.message":
    "Ein unerwarteter Fehler ist aufgereten.",
  "confirm-action.error.wrong-device.title": "Falsches Gerät",
  "confirm-action.error.wrong-device.message":
    "Dieser Link ist nur auf demselben Gerät gültig, das auch die Anfrage ausgelöst hat",

  "confirm-action.partially-confirmed.title": "Aktion wurde bestätigt!",
  "confirm-action.partially-confirmed.message":
    "Fahren Sie auf dem Gerät fort, dass diese Aktion ausgelöst hat.",
};
